export class CareGroupCancerTypes {
  id: number;
  careGroupId: number;
  cancerType: string;
  specialistId: number;
}
